import { Injectable } from '@angular/core';
import { Order, QueryConfig, QueryEntity } from '@datorama/akita';
import { MemberNetworkStore, MemberNetworkState } from './member-network.store';

@Injectable({ providedIn: 'root' })
@QueryConfig({ sortBy: 'TierPoints', sortByOrder: Order.DESC })
export class MemberNetworkQuery extends QueryEntity<MemberNetworkState> {
  constructor(protected store: MemberNetworkStore) {
    super(store);
  }

}
